<form #fAgency="ngForm" fxFlex [fxLayout]="layout" fxLayoutGap="8px grid" ngForm>
  <mat-form-field fxFlex appearance="outline" floatLabel="always">
    <mat-label>Agency Tier1</mat-label>
      <mat-select #t1 name="tier1Agency" ngModel (selectionChange)="onTier1AgencyChange()"
                  [ngModel]="t1State" [compareWith]="compareAgency" panelClass="epds-select-override-half" panelWidth="">
      <mat-option *ngFor="let agency of tier1Agencies" [value]="agency">
        {{agency.agency_Name}}
      </mat-option>
    </mat-select>
    <button mat-icon-button *ngIf="closeBtn && t1.value" matSuffix aria-label="Clear"
            (click)="t1.value=undefined; onTier1AgencyChange(); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field *ngIf="tier2Agencies && tier2Agencies.length>0" fxFlex appearance="outline" floatLabel="always">
    <mat-label>Agency Tier2</mat-label>
    <mat-select #t2 name="tier2Agency" ngModel [required]="tier2Required" (selectionChange)="onTier2AgencyChange()"
                [ngModel]="t2State" [compareWith]="compareAgency" panelClass="epds-select-override-half" panelWidth="">
      <mat-option *ngFor="let agency of tier2Agencies" [value]="agency">
        {{agency.agency_Name}}
      </mat-option>
    </mat-select>
    <button mat-icon-button *ngIf="closeBtn && t2.value" matSuffix aria-label="Clear"
            (click)="t2.value=undefined; onTier2AgencyChange(); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</form>
